<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <circle cx="24" cy="24" r="24" fill="#265957" />
    <path
      d="M31 31.9104V23.9104H24H17V31.9104M14 31.9104H34V19.9104L24.4938 16.2026C24.4679 16.1925 24.455 16.1875 24.4425 16.1818C24.4311 16.1766 24.4207 16.1714 24.4098 16.1654C24.3977 16.1589 24.3853 16.1512 24.3604 16.1357C24.2473 16.0656 24.181 16.0284 24.1108 16.0124C24.0379 15.9959 23.9621 15.9959 23.8892 16.0124C23.819 16.0284 23.7527 16.0656 23.6396 16.1357C23.6147 16.1512 23.6023 16.1589 23.5902 16.1654C23.5793 16.1714 23.5689 16.1766 23.5575 16.1818C23.545 16.1874 23.5321 16.1925 23.5062 16.2026L14 19.9104V31.9104Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
